export const DATE_FOUR_G_AVAILABILITY_DATA_IS_ACCURATE_FROM =
  '2026-03-11 11:31:00';
